/* tslint:disable */
/* eslint-disable */
/**
 * Atelier Roles API
 * L\'Atelier des rôles (BO admin) : référentiel des briques (standard verrouillées, personnalisées administrables), profils (ensembles de rôles appliqués à la création des acteurs) et matrice rôles/portails. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateBriqueCommand,
  GetBriquePermissionsResponse,
  GetProfilsResponse,
  GetReferentielBriquesResponse,
  OperationResponse,
  SetBriquePermissionsCommand,
  UpdateBriqueCommand,
} from '../models/index';
import {
    CreateBriqueCommandFromJSON,
    CreateBriqueCommandToJSON,
    GetBriquePermissionsResponseFromJSON,
    GetBriquePermissionsResponseToJSON,
    GetProfilsResponseFromJSON,
    GetProfilsResponseToJSON,
    GetReferentielBriquesResponseFromJSON,
    GetReferentielBriquesResponseToJSON,
    OperationResponseFromJSON,
    OperationResponseToJSON,
    SetBriquePermissionsCommandFromJSON,
    SetBriquePermissionsCommandToJSON,
    UpdateBriqueCommandFromJSON,
    UpdateBriqueCommandToJSON,
} from '../models/index';

export interface ArchiverBriqueRequest {
    nom: string;
}

export interface CreateBriqueRequest {
    createBriqueCommand: CreateBriqueCommand;
}

export interface GetBriquePermissionsRequest {
    nom: string;
}

export interface SetBriquePermissionsRequest {
    nom: string;
    setBriquePermissionsCommand: SetBriquePermissionsCommand;
}

export interface UpdateBriqueRequest {
    nom: string;
    updateBriqueCommand: UpdateBriqueCommand;
}

/**
 * 
 */
export class AtelierRolesApi extends runtime.BaseAPI {

    /**
     * Archiver une brique personnalisée (refusé si elle a des porteurs)
     */
    async archiverBriqueRaw(requestParameters: ArchiverBriqueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['nom'] == null) {
            throw new runtime.RequiredError(
                'nom',
                'Required parameter "nom" was null or undefined when calling archiverBrique().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/atelier-roles/briques/{nom}`.replace(`{${"nom"}}`, encodeURIComponent(String(requestParameters['nom']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Archiver une brique personnalisée (refusé si elle a des porteurs)
     */
    async archiverBrique(requestParameters: ArchiverBriqueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.archiverBriqueRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Créer une brique personnalisée (duplication d\'une brique du catalogue)
     */
    async createBriqueRaw(requestParameters: CreateBriqueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['createBriqueCommand'] == null) {
            throw new runtime.RequiredError(
                'createBriqueCommand',
                'Required parameter "createBriqueCommand" was null or undefined when calling createBrique().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/atelier-roles/briques`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBriqueCommandToJSON(requestParameters['createBriqueCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Créer une brique personnalisée (duplication d\'une brique du catalogue)
     */
    async createBrique(requestParameters: CreateBriqueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createBriqueRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Permissions d\'une brique, groupées par domaine métier
     */
    async getBriquePermissionsRaw(requestParameters: GetBriquePermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBriquePermissionsResponse>> {
        if (requestParameters['nom'] == null) {
            throw new runtime.RequiredError(
                'nom',
                'Required parameter "nom" was null or undefined when calling getBriquePermissions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/atelier-roles/briques/{nom}/permissions`.replace(`{${"nom"}}`, encodeURIComponent(String(requestParameters['nom']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBriquePermissionsResponseFromJSON(jsonValue));
    }

    /**
     * Permissions d\'une brique, groupées par domaine métier
     */
    async getBriquePermissions(requestParameters: GetBriquePermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBriquePermissionsResponse> {
        const response = await this.getBriquePermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Profils (consultation seule — figés, pilotés par le code)
     */
    async getProfilsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetProfilsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/atelier-roles/profils`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetProfilsResponseFromJSON(jsonValue));
    }

    /**
     * Profils (consultation seule — figés, pilotés par le code)
     */
    async getProfils(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetProfilsResponse> {
        const response = await this.getProfilsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Référentiel des briques
     */
    async getReferentielRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetReferentielBriquesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/atelier-roles/briques`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetReferentielBriquesResponseFromJSON(jsonValue));
    }

    /**
     * Référentiel des briques
     */
    async getReferentiel(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetReferentielBriquesResponse> {
        const response = await this.getReferentielRaw(initOverrides);
        return await response.value();
    }

    /**
     * Fixer la liste COMPLÈTE des permissions d\'une brique personnalisée
     */
    async setBriquePermissionsRaw(requestParameters: SetBriquePermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['nom'] == null) {
            throw new runtime.RequiredError(
                'nom',
                'Required parameter "nom" was null or undefined when calling setBriquePermissions().'
            );
        }

        if (requestParameters['setBriquePermissionsCommand'] == null) {
            throw new runtime.RequiredError(
                'setBriquePermissionsCommand',
                'Required parameter "setBriquePermissionsCommand" was null or undefined when calling setBriquePermissions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/atelier-roles/briques/{nom}/permissions`.replace(`{${"nom"}}`, encodeURIComponent(String(requestParameters['nom']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetBriquePermissionsCommandToJSON(requestParameters['setBriquePermissionsCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Fixer la liste COMPLÈTE des permissions d\'une brique personnalisée
     */
    async setBriquePermissions(requestParameters: SetBriquePermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.setBriquePermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mettre à jour une brique personnalisée (description, portails)
     */
    async updateBriqueRaw(requestParameters: UpdateBriqueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['nom'] == null) {
            throw new runtime.RequiredError(
                'nom',
                'Required parameter "nom" was null or undefined when calling updateBrique().'
            );
        }

        if (requestParameters['updateBriqueCommand'] == null) {
            throw new runtime.RequiredError(
                'updateBriqueCommand',
                'Required parameter "updateBriqueCommand" was null or undefined when calling updateBrique().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/atelier-roles/briques/{nom}`.replace(`{${"nom"}}`, encodeURIComponent(String(requestParameters['nom']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBriqueCommandToJSON(requestParameters['updateBriqueCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Mettre à jour une brique personnalisée (description, portails)
     */
    async updateBrique(requestParameters: UpdateBriqueRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.updateBriqueRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
